import fonts from "./fonts";

const typeset = {
    fontFamily:fonts.primary,
    secondaryFontFamily: fonts.secondary,
    h1:{
        fontSize:96
    },
    h2:{
        fontSize:60
    },
    h3:{
        fontSize:48
    },
    h4:{
        fontSize:34
    },
    h5:{
        fontSize:24
    },
    h6:{
        fontSize:20
    },
    body1:{
        fontSize:18
    },
    subtitle2:{
        fontSize:14
    },
    button:{
        fontSize:14
    },
    body2:{
        fontSize:16
    },
    caption:{
        fontSize:12
    },
    overline:{
        fontSize:10
    },
}

export default typeset;